"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversionEventToJSON = exports.ConversionEventFromJSONTyped = exports.ConversionEventFromJSON = exports.instanceOfConversionEvent = exports.ConversionEventTrackingEventTypeEnum = void 0;
/**
 * @export
 */
exports.ConversionEventTrackingEventTypeEnum = {
    Impression: 'IMPRESSION',
    Clicked: 'CLICKED',
    Complete: 'COMPLETE'
};
/**
 * Check if a given object implements the ConversionEvent interface.
 */
function instanceOfConversionEvent(value) {
    var isInstance = true;
    isInstance = isInstance && "trackingEventType" in value;
    isInstance = isInstance && "windowDurationMs" in value;
    return isInstance;
}
exports.instanceOfConversionEvent = instanceOfConversionEvent;
function ConversionEventFromJSON(json) {
    return ConversionEventFromJSONTyped(json, false);
}
exports.ConversionEventFromJSON = ConversionEventFromJSON;
function ConversionEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'trackingEventType': json['tracking_event_type'],
        'windowDurationMs': json['window_duration_ms'],
    };
}
exports.ConversionEventFromJSONTyped = ConversionEventFromJSONTyped;
function ConversionEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tracking_event_type': value.trackingEventType,
        'window_duration_ms': value.windowDurationMs,
    };
}
exports.ConversionEventToJSON = ConversionEventToJSON;
